import type { EChartsOption, ECharts } from 'echarts'
import Box from '@mui/material/Box'
import { useEffect, useRef } from 'react'
import { init, getInstanceByDom } from 'echarts'

export type BarChartProps = {
  title: string
  data: { name: string; value: number }[]
}

export default function BarChart(props: BarChartProps) {
  const chartRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let chart: ECharts
    if (chartRef.current !== null) {
      chart = init(chartRef.current, 'light')
    }
    function resizeChart() {
      chart?.resize()
    }
    window.addEventListener('resize', resizeChart)

    return () => {
      chart?.dispose()
      window.removeEventListener('resize', resizeChart)
    }
  }, [])

  useEffect(() => {
    const xAxis = []
    const series = []
    for (const data of props.data) {
      xAxis.push(data.name)
      series.push(data.value)
    }
    const option: EChartsOption = {
      title: {
        text: props.title
      },
      tooltip: {
        trigger: 'axis'
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: { show: true }
        }
      },
      xAxis: {
        type: 'category',
        data: xAxis
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: series,
          type: 'bar'
        }
      ]
    }
    if (chartRef.current !== null) {
      const chart = getInstanceByDom(chartRef.current)
      chart?.setOption(option)
    }
  }, [props.data, props.title])

  return (
    <Box sx={{ width: '100%' }}>
      <div ref={chartRef} style={{ width: '100%', height: '100%', minHeight: '300px' }} />
    </Box>
  )
}
